import Config from '@config';
import { createApi } from '@reduxjs/toolkit/query/react';

import {
  FinancesSummary,
  GetActsParams,
  GetActsResult,
  GetFinancesSummaryParams,
  GetPaymentsParams,
  GetPaymentsResult,
} from '@/features/finances/types';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const financesApi = createApi({
  reducerPath: 'financesApi',
  baseQuery: axiosBaseQuery({
    baseUrl: Config.VITE_API_URL + '/finances',
  }),
  tagTypes: ['FinancesSummary', 'Payment', 'Act'],
  endpoints: builder => ({
    getFinancesSummary: builder.query<FinancesSummary, GetFinancesSummaryParams>({
      query: params => ({
        url: '/summary',
        params,
      }),
      providesTags: ['FinancesSummary'],
    }),
    getPayments: builder.query<GetPaymentsResult, GetPaymentsParams>({
      query: params => ({
        url: '/payments',
        params,
      }),
      providesTags: ['Payment'],
    }),
    getActs: builder.query<GetActsResult, GetActsParams>({
      query: params => ({
        url: '/acts',
        params,
      }),
      providesTags: ['Act'],
    }),
  }),
});

export const {
  useGetFinancesSummaryQuery,
  useGetPaymentsQuery,
  useGetActsQuery,
} = financesApi;
